import styled from 'styled-components';

export const FooterWrapper = styled.div`
    margin-top: 35px
`;
